import React from "react";
import { Route, Routes } from "react-router-dom";
import GetToken from "../Pages/GetToken";

const GetTokenStack = () => {
  return (
    <Routes>
      <Route index element={<GetToken />} />
    </Routes>
  );
};

export default GetTokenStack;
